import { connect } from 'react-redux';
import { getEditorDraft as getEditorDraftNew } from '@wix/da-editor-tiptap/pkg/clientDrafts/selectors';
import { isInitialized, getCommentState } from '../../redux/selectors';
import { generateReplyEditorId } from '../../utils';
const getPropWithSelector = (state, commentId, selector, defaultValue)=>{
    if (isInitialized(commentId)(state)) {
        return selector(commentId)(state);
    }
    return defaultValue;
};
const mapStateToProps = (state, ownProps)=>{
    return {
        comment: getPropWithSelector(state, ownProps.comment.commentId, getCommentState, ownProps.comment),
        hasReplyDraft: !!getEditorDraftNew(state, generateReplyEditorId(ownProps.comment))
    };
};
export default connect(mapStateToProps);

//# sourceMappingURL=CommentContextProvider.container.js.map